<div class="flex flex-col gap-4">
  @if (!totpSecret) {
    <p class="text-sm text-gray-600">
      Use an authenticator app (Google Authenticator, Authy, etc.) to scan the
      QR code.
    </p>
    <pt-loader-button
      type="raised"
      color="primary"
      [loading]="isLoading()"
      (clicked)="generateQrCode()"
    >
      Generate QR Code
    </pt-loader-button>
  } @else {
    <div class="flex flex-col items-center gap-4">
      <p class="text-sm text-gray-600">
        Scan this QR code with your authenticator app, then enter the 6-digit
        code below.
      </p>
      @if (qrCodeUrl) {
        <qrcode
          class="rounded border border-gray-200 p-2"
          errorCorrectionLevel="M"
          [qrdata]="qrCodeUrl"
          [width]="200"
        />
      }
      <details class="w-full text-xs text-gray-500">
        <summary class="cursor-pointer">Can't scan? Enter key manually</summary>
        <code class="mt-1 block break-all">{{ totpSecret.secretKey }}</code>
      </details>
    </div>

    <form class="flex flex-col gap-4" [formGroup]="codeForm">
      <mat-form-field appearance="outline">
        <mat-label>Authenticator Code</mat-label>
        <input
          matInput
          formControlName="code"
          placeholder="123456"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
        />
        @if (codeForm.controls.code.hasError('required')) {
          <mat-error>Code is required</mat-error>
        }
      </mat-form-field>
      <pt-loader-button
        type="raised"
        color="primary"
        [loading]="isLoading()"
        [disabled]="!codeForm.valid"
        (clicked)="confirmEnrolment()"
      >
        Verify and Enrol
      </pt-loader-button>
    </form>
  }

  @if (errorMessage) {
    <p class="text-sm text-red-500">{{ errorMessage }}</p>
  }

  <button mat-stroked-button (click)="auth.logout()">Go Back</button>
</div>
